
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bcgtalk2022",
      function () {
        return require("private-next-pages/bcgtalk2022.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bcgtalk2022"])
      });
    }
  